import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import size from 'lodash/size';
import orderBy from 'lodash/orderBy';
import each from 'lodash/each';
import filter from 'lodash/filter';
import PoppingProgress from '../models/PoppingProgress';
import {
    onDeleteImage,
    onPoppingError,
    onPoppingFinished,
    onPoppingProgress,
    onProcessingImagesDeleteAllFailed,
    onProcessingImagesNav,
    onProcessingImagesToggle,
    onProcessingImagesDrag
} from '../actions/ImageActions';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import ProcessingImagePreview from '../components/ProcessingImagePreview';
import {count, nextIndex, prevIndex} from '../utils';
import {apiRoot} from '../Api';
import Draggable from 'react-draggable';

@connect(state => ({processingImages: state.processingImages}), {
    onPoppingProgress,
    onPoppingFinished,
    onPoppingError,
    onProcessingImagesNav,
    onProcessingImagesToggle,
    onProcessingImagesDrag,
    onDeleteImage,
    onDeleteAllFailed: onProcessingImagesDeleteAllFailed,
})
export default class ProcessingImages extends Component {
    static propTypes = {
        onPoppingProgress: PropTypes.func,
        onPoppingFinished: PropTypes.func,
        onPoppingError: PropTypes.func,
        onProcessingImagesNav: PropTypes.func,
        onProcessingImagesToggle: PropTypes.func,
        onProcessingImagesDrag: PropTypes.func,
        onDeleteImage: PropTypes.func,
        onDeleteAllFailed: PropTypes.func,
        onRetryAllFailed: PropTypes.func,
        processingImages: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const {x, y} = props.processingImages;
        this.defaultPosition = {x, y};
    }

    componentDidMount() {
        this.startTracking(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.startTracking(nextProps);
    }

    startTracking = (props) => {
        each(props.processingImages.items, image => {
            PoppingProgress.start(image, props);
        });
    };

    handleNav = (e, idx) => {
        e.preventDefault();
        this.props.onProcessingImagesNav(idx);
    };

    handleDragStop = (e, ui) => {
        this.props.onProcessingImagesDrag(ui.x, ui.y);
    };

    render() {
        const {processingImages: {items, showingIdx, visible}} = this.props;
        const imagesStillInProgress = filter(items, img => (!img.poppingPct || img.poppingPct < 100));
        const orderedItems = orderBy(imagesStillInProgress, ['poppingPct', 'uploadTime'], ['desc', 'desc']);
        const sz = size(orderedItems);
        if (!visible) {
            return false;
        }

        const idx = sz > showingIdx && showingIdx >= 0 ? showingIdx : 0;
        const pIdx = prevIndex(idx, sz);
        const nIdx = nextIndex(idx, sz);
        const image = orderedItems[idx];
        const errorCount = count(orderedItems, img => (img.error || (img.status === 'ABORTED') || (img.status === 'ERROR')));

        return (
            <Draggable handle=".drag-handle" onStop={this.handleDragStop} defaultPosition={this.defaultPosition}>
                <div className="processing">
                    <ButtonToolbar className="head-nav">
                        <div style={{display: 'inline-block'}} className="pull-left">
                            <DropdownButton bsStyle="link" title={<i className="fa fa-bars"/>} noCaret id="processing-options">
                                <MenuItem onClick={this.props.onDeleteAllFailed} disabled={errorCount === 0 || !this.props.onDeleteAllFailed}>
                                    {`Delete all ${errorCount ? errorCount : ''} failed images`}
                                </MenuItem>
                                <MenuItem onClick={this.props.onRetryAllFailed} disabled={errorCount === 0 || !this.props.onRetryAllFailed}>
                                    {`Retry all ${errorCount ? errorCount : ''} failed images`}
                                </MenuItem>
                                <MenuItem divider/>
                                <MenuItem onClick={this.props.onProcessingImagesToggle}>{'Hide'}</MenuItem>
                            </DropdownButton>
                        </div>
                        <div className="processing-drag-handle drag-handle"/>
                        <Button bsStyle="link" onClick={e => this.handleNav(e, pIdx)} className="pull-left" disabled={sz === 0 || idx === pIdx}
                                title="Previous">
                            <i className="fa fa-step-backward"/>
                        </Button>
                        <div className="pull-left processing-counts drag-handle">{sz > 0 ? `${idx + 1} of ${sz}` : ''}</div>
                        <Button bsStyle="link" onClick={e => this.handleNav(e, nIdx)} className="pull-left" disabled={sz === 0 || idx === nIdx}
                                title="Next">
                            <i className="fa fa-step-forward"/>
                        </Button>
                        <div className="processing-drag-handle drag-handle"/>
                        <Button bsStyle="link" onClick={this.props.onProcessingImagesToggle} className="pull-right close" title="Hide">
                            <i className="fa fa-close"/>
                        </Button>
                    </ButtonToolbar>
                    {sz > 0 &&
                    <ProcessingImagePreview image={image} srcPrefix={apiRoot} onDelete={this.props.onDeleteImage}/>
                    }
                    {sz === 0 &&
                    <div className="processing-empty">{'No images in progress'}</div>
                    }
                </div>
            </Draggable>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ProcessingImages.js